import React, { useEffect, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import {
  Box,
  Typography,
  Button,
  Avatar,
  CircularProgress,
} from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import { customTextColor, shortDateTime } from "../../utils/const";
import ReplyDrawer from "./ReplyDrawer";
import { getHotlistChatByCandidateId } from "../../redux/hotlist/hotListRecSlice";
import { useDispatch, useSelector } from "react-redux";
import { display } from "@mui/system";
import MsgDrawer from "./MsgDrawer";

const CandidateRequestDrawer = ({
  show,
  handleClose,
  candidateName,
  candidate,
}) => {
  const dispatch = useDispatch();
  const [showReplyDrawer, setShowReplyDrawer] = useState(false);
  const [expandedMessages, setExpandedMessages] = useState({});
  const [selectedChat, setSelectedChat] = useState(null);
  const reqList = useSelector((state) => state.hotlistrec.chatMessages || []);
  const loading = useSelector(
    (state) => state.hotlistrec.loading.getHotlistChatByCandidateId
  );
  console.log(candidate, reqList, loading);

  useEffect(() => {
    candidate?.id && dispatch(getHotlistChatByCandidateId(candidate?.id));
  }, [dispatch, candidate?.id]);

  const handleCloseReplyDrawer = () => {
    setSelectedChat(null);
    setShowReplyDrawer(false);
  };

  const handleOpenReplyDrawer = (request) => {
    setSelectedChat(request);
    setShowReplyDrawer(true);
  };

  const truncateText = (text, maxLength = 200) => {
    // Check if text is a string and not empty
    if (typeof text !== "string" || !text) {
      return "Message unavailable"; // Fallback if text is not a string
    }
    if (text.length <= maxLength) return text;
    return text.slice(0, maxLength) + "...";
  };

  const toggleMessageExpansion = (index) => {
    setExpandedMessages((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={true}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "65px",
        width: "50%",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.15)",
        backgroundColor: "#fff",
      }}
    >
      <Offcanvas.Body style={{ padding: 0, margin: 0 }}>
        <Box sx={{ padding: "10px 15px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0px 5px",
              mb: 2,
            }}
          >
            <Typography
              style={{
                color: customTextColor,
                fontWeight: "bold",
                fontSize: "16px",
              }}
            >
              Request for {candidate?.full_name}
            </Typography>
            <RxCross2
              style={{
                fontSize: "15px",
                cursor: "pointer",
                color: customTextColor,
              }}
              onClick={handleClose}
            />
          </Box>
          {loading === "pending" ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                padding: "20px",
              }}
            >
              <CircularProgress />
            </Box>
          ) : reqList?.length === 0 ? (
            <Typography
              style={{
                fontSize: "14px",
                color: customTextColor,
                textAlign: "center",
                padding: "20px",
              }}
            >
              No requests found
            </Typography>
          ) : (
            reqList?.map((request, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "10px",
                  border: "1px solid #e0e0e0",
                  borderRadius: "3px",
                  mb: "10px",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", mb: "10px" }}>
                  <Avatar
                    sx={{
                      width: 50,
                      height: 50,
                      mr: "10px",
                      borderRadius: "3px",
                    }}
                    src={
                      request?.user_profile_picture ||
                      "https://via.placeholder.com/42"
                    }
                  />
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography
                      style={{ fontSize: "14px", fontWeight: "bold" }}
                    >
                      {request?.latest_message_sender}
                    </Typography>
                    <Typography
                      style={{ fontSize: "12px", color: customTextColor }}
                    >
                      {request?.user_designation} - {request?.company_name}
                    </Typography>
                    <Typography
                      style={{ fontSize: "12px", color: customTextColor }}
                    >
                      {request?.user_details?.profiles[0]?.email ||
                        "Not provided"}
                    </Typography>
                  </Box>
                  <Typography
                    style={{ fontSize: "12px", color: customTextColor }}
                  >
                    {shortDateTime(request?.latest_message_timestamp)}
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography
                    style={{
                      fontSize: "14px",
                      whiteSpace: "pre-line",
                      mb: "10px",
                    }}
                  >
                    {expandedMessages[index] ||
                    request?.latest_message?.message?.length <= 200
                      ? request?.latest_message?.message
                      : truncateText(request?.latest_message?.message)}
                  </Typography>
                  {/* {request?.latest_message?.length > 100 && (
                  <Typography
                    style={{
                      fontSize: "12px",
                      color: customTextColor,
                      cursor: "pointer",
                      textDecoration: "underline",
                      mb: "10px",
                    }}
                    onClick={() => toggleMessageExpansion(index)}
                  >
                    {expandedMessages[index] ? "Read less" : "Read more"}
                  </Typography>
                )} */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "end",
                      ml: "15px",
                    }}
                  >
                    <Button
                      variant="contained"
                      onClick={() => handleOpenReplyDrawer(request)}
                      sx={{
                        backgroundColor: "#007bff",
                        textTransform: "capitalize",
                        borderRadius: "3px",
                        boxShadow: "none",
                        fontSize: "14px",
                        maxHeight: "30px",
                        padding: "4px 10px",
                        "&:hover": {
                          backgroundColor: "#0056b3",
                          boxShadow: "none",
                        },
                      }}
                    >
                      Reply
                    </Button>
                  </Box>
                </Box>
              </Box>
            ))
          )}
          {/* <ReplyDrawer
            show={showReplyDrawer}
            handleClose={handleCloseReplyDrawer}
            candidate={candidate}
            selectedChat={selectedChat} // Pass the selected chat to the ReplyDrawer
          /> */}
          <MsgDrawer
            show={showReplyDrawer}
            handleClose={handleCloseReplyDrawer}
            candidate={candidate}
            selectedChat={selectedChat} // Pass the selected chat to the ReplyDrawer
          />
        </Box>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default CandidateRequestDrawer;
